import {
  LuBell,
  LuBellRing,
  LuBookOpen,
  LuBriefcaseBusiness,
  LuBug,
  LuCalendarClock,
  LuCalendarDays,
  LuCircleGauge,
  LuFlag,
  LuFolderKanban,
  LuFolderOpen,
  LuGraduationCap,
  LuIdCard,
  LuLayoutDashboard,
  LuListChecks,
  LuListTodo,
  LuMegaphone,
  LuMessagesSquare,
  LuMonitor,
  LuPanelsTopLeft,
  LuReceipt,
  LuTreePalm,
  LuUserRound,
  LuWallet,
} from 'react-icons/lu';

/**
 * Chapters of the user guide, in order, grouped like the index of the player.
 * Every chapter is a topic a user can jump to; the texts are
 * userGuide.chapters.<key> (title) and userGuide.keywords.<key> (search words).
 */
export const GROUPS = [
  { key: 'start', chapters: ['intro', 'shell'] },
  { key: 'home', chapters: ['dashboard', 'tasks', 'projectsDialog', 'reminders'] },
  {
    key: 'profile',
    chapters: [
      'profileCard', 'completion', 'tabs', 'calendar', 'agenda', 'files', 'sop', 'training', 'myProjects',
      'leaveRequest', 'leaveList', 'expenseRequest', 'expenseTrack', 'messages', 'announcements', 'bugReport', 'cv',
    ],
  },
  { key: 'end', chapters: ['end'] },
];

export const CHAPTER_KEYS = GROUPS.flatMap((group) => group.chapters);

/** Topics offered as shortcuts on the home-page card. */
export const POPULAR_TOPICS = ['leaveRequest', 'expenseRequest', 'files', 'messages', 'cv'];

export const groupOfChapter = (chapter) => GROUPS.find((group) => group.chapters.includes(chapter));

export const CHAPTER_ICONS = {
  intro: LuBookOpen,
  shell: LuMonitor,
  dashboard: LuLayoutDashboard,
  tasks: LuListTodo,
  projectsDialog: LuFolderKanban,
  reminders: LuBellRing,
  profileCard: LuUserRound,
  completion: LuCircleGauge,
  tabs: LuPanelsTopLeft,
  calendar: LuCalendarDays,
  agenda: LuCalendarClock,
  files: LuFolderOpen,
  sop: LuListChecks,
  training: LuGraduationCap,
  myProjects: LuBriefcaseBusiness,
  leaveRequest: LuTreePalm,
  leaveList: LuTreePalm,
  expenseRequest: LuWallet,
  expenseTrack: LuReceipt,
  messages: LuMessagesSquare,
  announcements: LuMegaphone,
  bugReport: LuBug,
  cv: LuIdCard,
  end: LuFlag,
};

export const GROUP_ICONS = { start: LuBookOpen, home: LuLayoutDashboard, profile: LuUserRound, end: LuBell };
